import React, { useEffect } from 'react';
import CalculatorContainer from "./components/CalculatorContainer";
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import './App.css';

function App() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    // Temp controls for primary color to validate colors for different CUs
    const primaryColor = urlParams.get('color-primary');
    if (primaryColor) {
      document.querySelector(".calculator-container").style.setProperty('--color-primary', primaryColor);
    }
  }, []);

  return (
    <div className={`App`}>
      <CalculatorContainer></CalculatorContainer>
    </div>
  );
}

export default App;